import Vue from 'vue'
import DateService from '../helpers/DateServiceOld'

Object.defineProperties(Vue.prototype, {
  $date: {
    get() {
      return DateService
    }
  }
})
